import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";

const useStyles = createUseStyles((_) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "10px 15px 20px 15px",
  },
  divContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "& > div": {
      flex: 1,
    },
  },
  textModalContainer: {
    padding: "0px 0px 29px 0px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  /**
   * Impact panel. Blockers and collateral are visually distinct on purpose:
   * blockers mean "this cannot happen", collateral means "this goes too".
   */
  impactList: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    margin: 0,
    padding: "12px 14px",
    borderRadius: "8px",
    listStyle: "none",
  },
  impactBlocking: {
    backgroundColor: "rgba(255, 0, 0, 0.06)",
    borderLeft: `3px solid ${colors.error}`,
  },
  impactCollateral: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    borderLeft: "3px solid rgba(0, 0, 0, 0.25)",
  },
  impactRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
  },
  confirmField: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    paddingTop: "10px",
  },
  loaderRow: {
    display: "flex",
    justifyContent: "center",
    padding: "20px 0",
  },
}));

export default useStyles;
